import React from 'react';

const ContactSuggestionItem = ({contact, handleSelect}) => {
  return (
    <a className="cardSection _withColumns _simple">
      <div className="text">
        <p className="copy _noBottomMargin emphasize">
          {' '}
          {contact.first_name} {contact.last_name}{' '}
        </p>
        <p className="byline _noBottomMargin">
          {' '}
          {contact.work_contact_number}{' '}
        </p>
        <p className="byline"> {contact.email_address} </p>
      </div>
      <div
        data-test="select-contact-button"
        className="ds-btn -secondary --micro _widthAuto"
        onClick={() => handleSelect(contact)}>
        Select
      </div>
    </a>
  );
};

export default ContactSuggestionItem;



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/ContactSuggestionItem.js